import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Stitch, AnonymousCredential, RemoteMongoClient, UserPasswordCredential, UserPasswordAuthProviderClient } from 'mongodb-stitch-browser-sdk';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private client;
  private db;

  constructor() {
    if (!Stitch.hasAppClient('sofia-psqdb')) {
      this.client = Stitch.initializeDefaultAppClient('sofia-psqdb');
    }else{
      this.client = Stitch.defaultAppClient;
    }
    this.db = this.client.getServiceClient(RemoteMongoClient.factory, 'mongodb-atlas').db('sofia');
  }

  // Stitch
  login(params: any){
      const credential = new UserPasswordCredential(params.email, params.password);
      return this.client.auth.loginWithCredential(credential)
  }

  async obtenerUsuarioConId(id){
    return await this.client.callFunction("obtenerUsuarioConId", [id]);
  }

  async resetPassword(email){
    return await this.client.auth.getProviderClient(UserPasswordAuthProviderClient.factory).sendResetPasswordEmail(email);
  }

  async resetConfirmacion(email){
    return await this.client.auth.getProviderClient(UserPasswordAuthProviderClient.factory).resendConfirmationEmail(email);
  }

  logout(){
    return this.client.auth.logout();
  }

}
